"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBusEvent = exports.EventBus = void 0;
var EventBus = (function () {
    function EventBus() {
    }
    EventBus.prototype.listen = function (event, listener) {
        this.deafen(event, listener);
        EventBus.listeners[event].push(listener);
        return this;
    };
    EventBus.prototype.deafen = function (event, listener) {
        var list = EventBus.listeners[event] || [];
        var index = list.length;
        while (index--) {
            if (list[index] === listener) {
                list.splice(index, 1);
            }
        }
        EventBus.listeners[event] = list;
        return this;
    };
    EventBus.prototype.notify = function (event) {
        var extraArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraArgs[_i - 1] = arguments[_i];
        }
        var list = (EventBus.listeners[event] || []).concat();
        var size = list.length;
        var listener, index = 0;
        var newArgs = __spreadArray([new EventBusEvent(event)], extraArgs, true);
        for (; index < size; index++) {
            listener = list[index];
            if (typeof listener == 'function') {
                listener.apply(null, newArgs);
            }
            else if ('handleEvent' in listener
                && typeof listener.handleEvent == 'function') {
                listener.handleEvent.apply(listener, newArgs);
            }
        }
        return this;
    };
    EventBus.listeners = {};
    return EventBus;
}());
exports.EventBus = EventBus;
var EventBusEvent = (function () {
    function EventBusEvent(type) {
        if (typeof type != 'string') {
            throw new TypeError();
        }
        this.type = type;
    }
    return EventBusEvent;
}());
exports.EventBusEvent = EventBusEvent;
